import { Divider } from '@scaleaq/scaleui';
import styled from 'styled-components';

// Stretches with the row; compact sub-rows get a shorter bar.
export const StyledColorBar = styled(Divider)<{ $compact: boolean }>`
  min-height: ${({ $compact }) => ($compact ? '1.5rem' : '2.5rem')};
  height: stretch;
`;
